import * as constant from "./constant";
import { Get } from "utils/request";
import { API } from "utils/api";
import { message } from "antd";
import { clearLoginState, redirectToLocalLogin } from "utils/sso";

export const changeItem = (target, value) => ({
  type: constant.CHANGE_ITEM,
  target: target,
  value: value
});

/**
 * 注销。
 *
 * 认证中心侧的全局会话注销由后端 /api/logout 代持令牌完成，前端只做两件事：
 * 清理本地登录态、回到登录中转页（由它决定是否需要重新登录）。
 * 这里不能跳认证中心的 /api/logout——那是个只返回 JSON 的服务端接口。
 */
export const logout = () => {
  return (dispatch) => {
    Get(API.LOGOUT)
      .then(() => {
        clearLoginState();
        message.success("注销成功");
        redirectToLocalLogin();
      })
      .catch(() => {
        // 本地会话已失效时后端也可能报错，本地登录态照样要清掉
        clearLoginState();
        redirectToLocalLogin();
      });
  };
};
